var _class, _temp2, _class2, _temp3;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import { cx } from "emotion";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import DoneIcon from "@material-ui/icons/Done";
import ClearIcon from "@material-ui/icons/Clear";
import "./inline-editable-field.css";

export var InlineEditableFieldDisplay = function (_Component) {
  _inherits(InlineEditableFieldDisplay, _Component);

  function InlineEditableFieldDisplay() {
    _classCallCheck(this, InlineEditableFieldDisplay);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  InlineEditableFieldDisplay.prototype.render = function render() {
    return React.createElement(
      React.Fragment,
      null,
      this.props.children
    );
  };

  return InlineEditableFieldDisplay;
}(Component);

export var InlineEditableFieldContent = (_temp2 = _class = function (_Component2) {
  _inherits(InlineEditableFieldContent, _Component2);

  function InlineEditableFieldContent() {
    var _temp, _this2, _ret;

    _classCallCheck(this, InlineEditableFieldContent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
      value: _this2.props.value,
      error: null
    }, _this2.handleChange = function (_ref) {
      var target = _ref.target;

      _this2.setState({ value: target.value, error: null });
    }, _this2.handleSave = function () {
      var value = _this2.state.value;


      try {
        _this2.props.onSave(value);
        _this2.props.close();
      } catch (e) {
        _this2.setState({ error: e.message });
      }
    }, _temp), _possibleConstructorReturn(_this2, _ret);
  }

  InlineEditableFieldContent.prototype.render = function render() {
    var _state = this.state,
        value = _state.value,
        error = _state.error;
    var _props = this.props,
        label = _props.label,
        close = _props.close;


    return React.createElement(
      FormControl,
      { error: !!error },
      React.createElement(TextField, {
        variant: "outlined",
        type: "text",
        label: label,
        value: value,
        onChange: this.handleChange,
        InputProps: {
          endAdornment: React.createElement(
            InputAdornment,
            { position: "end" },
            React.createElement(
              IconButton,
              { edge: "end", onClick: this.handleSave },
              React.createElement(DoneIcon, null)
            ),
            React.createElement(
              IconButton,
              { edge: "end", onClick: close },
              React.createElement(ClearIcon, null)
            )
          )
        },
        error: !!error
      }),
      React.createElement(
        FormHelperText,
        null,
        error
      )
    );
  };

  return InlineEditableFieldContent;
}(Component), _class.defaultProps = {
  style: null,
  className: null,
  active: false,
  closable: false,
  disabled: false,
  tabIndex: "0",
  onOpen: null,
  onClose: null,
  onToggle: null
}, _temp2);

export var InlineEditableField = (_temp3 = _class2 = function (_Component3) {
  _inherits(InlineEditableField, _Component3);

  function InlineEditableField(props) {
    _classCallCheck(this, InlineEditableField);

    var _this3 = _possibleConstructorReturn(this, _Component3.call(this, props));

    if (!_this3.props.onToggle) {
      _this3.state = {
        active: false
      };
    }

    _this3.open = _this3.open.bind(_this3);
    _this3.close = _this3.close.bind(_this3);
    _this3.onDisplayKeyDown = _this3.onDisplayKeyDown.bind(_this3);
    return _this3;
  }

  InlineEditableField.prototype.open = function open(event) {
    if (this.props.disabled) {
      return;
    }

    if (this.props.onOpen) {
      this.props.onOpen(event);
    }
    if (this.props.onToggle) {
      this.props.onToggle({
        originalEvent: event,
        value: true
      });
    } else {
      this.setState({
        active: true
      });
    }
  };

  InlineEditableField.prototype.close = function close(event) {
    if (this.props.onClose) {
      this.props.onClose(event);
    }

    if (this.props.onToggle) {
      this.props.onToggle({
        originalEvent: event,
        value: false
      });
    } else {
      this.setState({
        active: false
      });
    }
  };

  InlineEditableField.prototype.onDisplayKeyDown = function onDisplayKeyDown(event) {
    if (event.key === "Enter") {
      this.open(event);
      event.preventDefault();
    }
  };

  InlineEditableField.prototype.isActive = function isActive() {
    return this.props.onToggle ? this.props.active : this.state.active;
  };

  InlineEditableField.prototype.renderDisplay = function renderDisplay() {
    var className = cx("p-inplace-display", {
      "p-disabled": this.props.disabled
    });

    return React.createElement(
      "div",
      {
        className: className,
        onClick: this.open,
        onKeyDown: this.onDisplayKeyDown,
        tabIndex: this.props.tabIndex
      },
      React.createElement(
        InlineEditableFieldDisplay,
        null,
        this.props.value
      )
    );
  };

  InlineEditableField.prototype.renderCloseButton = function renderCloseButton() {
    if (this.props.closable) {
      return React.createElement(
        "button",
        { type: "button", onClick: this.close },
        "x"
      );
    } else {
      return null;
    }
  };

  InlineEditableField.prototype.renderContent = function renderContent(content) {
    var closeButton = this.renderCloseButton();

    return React.createElement(
      "div",
      { className: "p-inplace-content" },
      content,
      closeButton
    );
  };

  InlineEditableField.prototype.renderChildren = function renderChildren() {
    var _this4 = this;

    var active = this.isActive();

    return React.Children.map(this.props.children, function (child) {
      if (active && child.type === InlineEditableFieldContent) {
        return _this4.renderContent(child);
      } else if (!active && child.type === InlineEditableFieldDisplay) {
        return _this4.renderDisplay(child);
      }
    });
  };

  InlineEditableField.prototype.render = function render() {
    var _props2 = this.props,
        label = _props2.label,
        value = _props2.value,
        _props2$editable = _props2.editable,
        editable = _props2$editable === undefined ? true : _props2$editable,
        onSave = _props2.onSave;

    var active = this.isActive();
    var className = cx("reactivepad p-inplace p-component", { "p-inplace-closable": this.props.closable }, this.props.className);

    return React.createElement(
      "div",
      { className: className },
      !active || !editable ? this.renderDisplay(this.props.children) : React.createElement(InlineEditableFieldContent, {
        label: label,
        value: value,
        onSave: onSave,
        close: this.close
      })
    );
  };

  return InlineEditableField;
}(Component), _class2.defaultProps = {
  style: null,
  className: null,
  active: false,
  closable: false,
  disabled: false,
  tabIndex: "0",
  onOpen: null,
  onClose: null,
  onToggle: null
}, _temp3);